import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

// import the root reducer

import createReducer from './reducers/index';

import rootSaga from './sagas/index';

// create an object for the default data

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

const defaultState = {
  event: eventDataProps,
};

const enhancers = [applyMiddleware(...middlewares)];

// window.devToolsExtension ? window.devToolsExtension() : f => f
const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const configureStore = (initialState = defaultState) => {
  return createStore(createReducer(), initialState, composeEnhancers(...enhancers));
};

const store = configureStore();

/*
const routerHistory = useNavigate();(createHistory)({
	basename: APP.BASENAME
});
export const history= syncHistoryWithStore(routerHistory, store);
*/
// Extentions
store.runSaga = sagaMiddleware.run(rootSaga);
store.asyncReducers = {};

export default store;
